import useSettingForm from '../form/useSettingForm';
import { useDomain } from '../../../../states/AppDomainProvider';
import MaxChoices from '../../../settings/interaction/MaxChoices';

const MaxChoicesSettings = () => {
  const { updateProfileSettingsOnChange } = useSettingForm('Max Choices');
  const { userDomain } = useDomain();
  const { userProfile } = userDomain.domainData;

  const onChange = (newValue) => {
    updateProfileSettingsOnChange({
      maxMatchingChoices: newValue,
    });
  };

  return (
    <MaxChoices
      profile={userProfile}
      onChangeCallback={(newValue) => onChange(newValue)}
    />
  );
};

export default MaxChoicesSettings;
